export default __webpack_public_path__ + "static/media/german_books.c00869b4.png";